import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CollateralCustomerService from "services/Setup/LoanOrigination/CollateralManagement/CollateralCustomerService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingReturn: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  collateralCustomerList: [],
  statusRespon: 0,
  statusResponReturn: 0,
};

const handleApiResponse = (response, rejectWithValue) => {
  if (response.status === 200) {
    if (response.data.status == "Success") {
      notification.success({
        message: response.data.status,
        description: response.data.message,
        duration: 3,
      });
    } else {
      notification.error({
        message: response.data.status,
        description: response.data.message,
        duration: 3,
      });
    }
    return response.data;
  } else {
    console.log("Selain Response 200");
    notification.error({
      message: "Error",
      description: "Unexpected response!",
      duration: 3,
    });
    return rejectWithValue({
      status: "Error",
      response: response?.data?.message || "Unexpected response!",
    });
  }
};

const handleApiError = (error, rejectWithValue) => {
  notification.error({
    message: error.response?.status || "Error",
    description: error.response?.statusText || "Unexpected error occurred",
    duration: 3,
  });
  return rejectWithValue(
    error.response?.data?.message || "Unexpected response!"
  );
};

export const postCollateralManagementSlice = createAsyncThunk(
  "CollateralCustomer/postCollateralManagementSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      // console.log("responspostCollateralManagementSlicee", userInput);
      const response =
        await CollateralCustomerService.posCollateralCustomerService(userInput);

      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const getCollateralCustomerApprovalSlice = createAsyncThunk(
  "CollateralCustomer/getCollateralCustomerApprovalSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      console.log("userInput", userInput);

      const response =
        await CollateralCustomerService.getCollateralCustomerApprovalService(
          userInput
        );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const getCollateralCustomerSlice = createAsyncThunk(
  "CollateralCustomer/getCollateralCustomerSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      console.log("userInput", userInput);

      const response =
        await CollateralCustomerService.getCollateralCustomerService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const putCollateralCustomerApprovalSlice = createAsyncThunk(
  "CollateralCustomer/putCollateralCustomerApprovalSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      // console.log("responspostCollateralManagementSlicee", userInput);
      const response =
        await CollateralCustomerService.putCollateralCustomerApprovalService(
          userInput
        );

      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const deleteCollateralCustomerSlice = createAsyncThunk(
  "CollateralCustomer/deleteCollateralCustomerSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      // console.log("responspostCollateralManagementSlicee", userInput);
      const response =
        await CollateralCustomerService.deleteCollateralCustomerService(
          userInput
        );

      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

// return
export const putCollateralCustomerReturnSlice = createAsyncThunk(
  "CollateralCustomer/putCollateralCustomerReturnSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralCustomerService.putCollateralCustomerReturnService(
          userInput
        );
      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const CollateralManagementSlice = createSlice({
  name: "CollateralCustomer",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state, action) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state, action) => {
      state.loading = true;
    },
    resetStatusRespon: (state, action) => {
      state.statusRespon = "";
      state.statusResponReturn = "";
    },
    setcreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postCollateralManagementSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(postCollateralManagementSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(postCollateralManagementSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // get all
      .addCase(getCollateralCustomerApprovalSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(
        getCollateralCustomerApprovalSlice.fulfilled,
        (state, action) => {
          state.loading = false;
          state.collateralCustomerList = action?.payload;
          state.getCount = action.payload.count;
        }
      )
      .addCase(getCollateralCustomerApprovalSlice.pending, (state, action) => {
        state.loading = true;
        state.redirect = "";
      })

      // get all
      .addCase(getCollateralCustomerSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(getCollateralCustomerSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralCustomerList = action?.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCollateralCustomerSlice.pending, (state, action) => {
        state.loading = true;
        state.redirect = "";
      })

      // approval
      .addCase(putCollateralCustomerApprovalSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        putCollateralCustomerApprovalSlice.fulfilled,
        (state, action) => {
          state.loading = false;
          state.redirect = "/";
          state.result = action.payload;
          state.showMessage = true;
          state.message = action?.payload?.message;
          state.refreshList = true;
          state.statusRespon = action?.payload?.status;
        }
      )
      .addCase(putCollateralCustomerApprovalSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // delete
      .addCase(deleteCollateralCustomerSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteCollateralCustomerSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(deleteCollateralCustomerSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   return
      .addCase(putCollateralCustomerReturnSlice.pending, (state, action) => {
        state.loadingReturn = true;
        state.statusRespon = "";
      })
      .addCase(putCollateralCustomerReturnSlice.fulfilled, (state, action) => {
        state.loadingReturn = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusResponReturn = action?.payload?.status;
        state.statusRespon = "";
      })
      .addCase(putCollateralCustomerReturnSlice.rejected, (state, action) => {
        state.loadingReturn = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "";
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
} = CollateralManagementSlice.actions;

export default CollateralManagementSlice.reducer;
